export enum PageType {
  Article = "article",
  Author = "author",
  Authors = "authors",
  Homepage = "homepage",
  Live = "live",
  Opinion = "opinion",
  Others = "others",
  Page = "page",
  Podcast = "podcast",
  Posties = "posties",
  Section = "section",
  Series = "series",
  StoryStyle = "story-style",
  Topic = "topic",
  Topics = "topics",
}
